import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const fired = new Set();

export const trackDemoEvent = (event, once = true) => {
  if (once && fired.has(event)) return;
  fired.add(event);
  try {
    axios.post(`${API_URL}/api/public/demo-analytics`, {
      event,
      session_key: sessionStorage.getItem('demo_sk') || (() => {
        const k = Math.random().toString(36).slice(2);
        sessionStorage.setItem('demo_sk', k);
        return k;
      })(),
    }).catch(() => {});
  } catch (e) { /* silencioso */ }
};
